<template>
    <div class="audit-badge">
        <b-badge
            class="badge-link"
            v-if="audit"
            :variant="variant"
            @click="editAudit"><a>{{ status }}</a></b-badge>
    </div>
</template>

<script>
import moment from 'moment'

export default {
    name: 'AuditBadge',
    props: {
        audit: Object
    },
    computed: {
        formattedDate () {
            // empty (or invalid) date
            if (!moment(this.date).isValid()) {
                return ''
            }

            let format = 'MMM D'    // Jan 26

            return moment.utc(this.date).local().format(format)
        },
        status () {
            if (this.audit.status === 'IN_PROGRESS') {
                return 'In Progress - Started ' + this.formattedDate
            } else if (this.audit.status === 'COMPLETED') {
                return 'Completed On ' + this.formattedDate
            }
            return ''
        },
        variant () {
            if (this.audit.status === 'IN_PROGRESS') {
                return 'warning'
            } else if (this.audit.status === 'COMPLETED') {
                return 'primary'
            }
            return 'dark'

        }
    },
    methods: {
        editAudit () {
            this.$router.push('/audit/edit/' + this.audit.id)
        }
    },
}
</script>
